import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import DocumentTitle from 'react-document-title'

import AtheneumContacts from './AtheneumContacts'
import Actions from './Actions'
import Paragraph from '@components/Details/Paragraph'
import { Dropdown } from '@components/Autocomplete'
import ProjectDetails from './ProjectDetails'
import ProjectIndicators from './ProjectIndicators'
import Segments from './Segments'
import InfoBox from '@components/InfoBox/InfoBox'
import Comments from '@components/Comments'
import Attachment, { confirmDelete } from '@components/Attachment'

class Details extends Component {
  static propTypes = {
    projectStore: PropTypes.object.isRequired
  }

  renderClientLanguages = () => {
    const { project } = this.props.projectStore
    if (!project.languages || project.languages.length < 1) return '-'
    return project.languages.map((language, index) => {
      return index + 1 === project.languages.length
        ? language.name
        : `${language.name}, `
    })
  }

  render () {
    const { project, segmentStore } = this.props.projectStore
    return (
      <DocumentTitle
        title={`${project.projectName} - details | Atheneum Partners`}
      >
        <div className='details-wrapper animate-intro'>
          <Actions project={project} />
          <AtheneumContacts />

          {segmentStore.isEmpty ? (
            <InfoBox theme='red'>
              <span>This project still has no segments defined.</span>
            </InfoBox>
          ) : null}

          <div className='content'>
            <div className='col-2'>
              <Paragraph
                title='Background'
                value={project.background}
                tooltip='Project Background including Scope and Companies of Interest is given in this field.'
              />
              <Paragraph
                title='Blacklisted companies'
                value={project.blacklistedCompanies}
              />

              <Paragraph
                title='Invoicing instructions'
                value={project.invoicingInstructions}
              />

              <Attachment
                attachments={this.props.projectStore.attachments}
                url={
                  '/api/project/' +
                  this.props.projectStore.project.id +
                  '/attachments'
                }
                onOk={() =>
                  this.props.projectStore.getAttachments(
                    this.props.projectStore.project.id
                  )
                }
                onDelete={fileId =>
                  confirmDelete(
                    fileId,
                    this.props.projectStore.deleteAttachment
                  )
                }
                tooltip={
                  <p>
                    Please keep file names unique and descriptive so that users
                    can recognize what the file is. Do not upload duplicate
                    files. Would you want to replace it, delete the old one
                    first.
                  </p>
                }
              />
            </div>

            <div className='col-2 col-2--padding'>
              <ProjectDetails />
              <ProjectManagementSection />
              <Segments
                project={project}
                showButton={!this.props.projectStore.capiDetails}
              />
              <ProjectIndicators />
              <InfoBox tooltip='This information is visible and editable by Client.'>
                <div className='single'>
                  <span>Client availability</span>
                  <p>{project.clientAvailabilities || '-'}</p>
                </div>
                <div className='single'>
                  <span>Preferred client languages</span>
                  <p>{this.renderClientLanguages()}</p>
                </div>
              </InfoBox>
            </div>
          </div>

          <Comments modelId={this.props.projectStore.id} model='project' />
        </div>
      </DocumentTitle>
    )
  }
}

const ProjectManagementSection = inject(
  'staticData',
  'projectStore',
  'userStore'
)(
  observer(({ staticData, projectStore, userStore }) => {
    return (
      <div>
        <h2>Project Management</h2>
        <div
          style={{ display: 'flex', alignItems: 'center', marginBottom: 15 }}
        >
          <label style={{ width: 190, marginBottom: 0 }}>Priority</label>
          <div style={{ flexGrow: 1 }}>
            <Dropdown
              selectedItem={projectStore.project.priorityId}
              valueIsId
              disabled={
                !projectStore.project.employees
                  .map(u => u.id)
                  .includes(userStore.user.id)
              }
              options={staticData.priorities}
              onChange={val => projectStore.updatePriority(val.id)}
              itemToString={i => i.name}
            />
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <label style={{ width: 190, marginBottom: 0 }}>Action</label>
          <div style={{ flexGrow: 1 }}>
            <Dropdown
              selectedItem={projectStore.project.actionId}
              disabled={
                !projectStore.project.employees
                  .map(u => u.id)
                  .includes(userStore.user.id)
              }
              valueIsId
              options={projectStore.actions}
              onChange={val => projectStore.updateAction(val.id)}
              itemToString={i => i.name}
            />
          </div>
        </div>
      </div>
    )
  })
)

export default inject('projectStore')(observer(Details))
